namespace Solovis.UI {

    export interface DockPanelControlOptions extends Solovis.UI.BaseControlOptions {
        headerHeight?: any;
        footerHeight?: any;
        sizeToViewport?: boolean;
    }

    /*
     * DockPanelControl can host controls in a header/footer area.
     */
    export class DockPanelControl extends Solovis.UI.BaseControl {

        public _headerHeight: any;
        public _footerHeight: any;
        public _sizeToViewport: any;

        public _headerPanelDiv: JQuery;
        public _headerPanelControlHost: Solovis.UI.ControlHost;
        public _mainPanelDiv: JQuery;
        public _mainPanelControlHost: Solovis.UI.ControlHost;
        public _footerPanelDiv: JQuery;
        public _footerPanelControlHost: Solovis.UI.ControlHost;

        public _windowResizeHandler: any;


        constructor(options: DockPanelControlOptions) {
            super(options);

            this._headerHeight = options.headerHeight;
            this._footerHeight = options.footerHeight;
            this._sizeToViewport = options.sizeToViewport ? true : false;
        }

        public doInit() {
        }

        public doRender() {
            var self = this;

            this._headerPanelDiv = $("<div>").addClass("dock-panel-header").appendTo(this.container);
            if (Solovis.isNotNull(this._headerHeight)) {
                this._headerPanelDiv.height(this._headerHeight);
            }
            this._headerPanelControlHost = new Solovis.UI.ControlHost({ container: this._headerPanelDiv });

            this._mainPanelDiv = $("<div>")
                .addClass("dock-panel-body")
                .css("overflow", "auto")
                .appendTo(this.container);
            this._mainPanelControlHost = new Solovis.UI.ControlHost({ container: this._mainPanelDiv });

            this._footerPanelDiv = $("<div>").addClass("dock-panel-footer").appendTo(this.container);
            if (Solovis.isNotNull(this._footerHeight)) {
                this._footerPanelDiv.height(this._footerHeight);
            }
            this._footerPanelControlHost = new Solovis.UI.ControlHost({ container: this._footerPanelDiv });

            if (this._sizeToViewport) {
                // Disable scrolling on the document body since our dock panel will control scrolling for content and should take the entire viewport.
                $(document.body).css("overflow", "hidden");
                (document.body as any).__DockPanelControlDisabledScroll = true;

                this._mainPanelDiv.css("overflow", "auto");
                this._resizeToViewport();

                this._windowResizeHandler = function () {
                    self._resizeToViewport();
                };

                $(window).bind("resize", this._windowResizeHandler);
            }
        }

        public getMainPanelControlHost() {
            return this._mainPanelControlHost;
        }

        public getHeaderPanelControlHost() {
            return this._headerPanelControlHost;
        }

        public getFooterPanelControlHost() {
            return this._footerPanelControlHost;
        }

        public _resizeToViewport() {
            var containerTop = $(this.container).offset().top;
            var windowHeight = $(window).height();

            var overallHeight = windowHeight - containerTop;

            this.setAvailableHeight(overallHeight);
        }

        public getAvailableHeight() : number {
            var headerHeight = $(this._headerPanelDiv).outerHeight();
            var footerHeight = $(this._footerPanelDiv).outerHeight();
            var mainPanelHeight = this._mainPanelDiv.height();
            return mainPanelHeight + headerHeight + footerHeight;
        }

        public setAvailableHeight(overallHeight) {
            var headerHeight = $(this._headerPanelDiv).outerHeight();
            var footerHeight = $(this._footerPanelDiv).outerHeight();

            var availableHeight = overallHeight - headerHeight - footerHeight;
            this._mainPanelDiv.height(availableHeight);
        }

        public doDestroy() {
            if (this._windowResizeHandler) {
                $(window).bind("resize", this._windowResizeHandler);
                this._windowResizeHandler = null;
            }

            this._headerPanelControlHost.setCurrentControl(null);
            this._mainPanelControlHost.setCurrentControl(null);
            this._footerPanelControlHost.setCurrentControl(null);
        }

        public setHeaderPanelControl(control) {
            this._headerPanelControlHost.setCurrentControl(control);

            if (this._sizeToViewport) {
                this._resizeToViewport();
            }
        }

        public setMainPanelControl(control) {
            this._mainPanelControlHost.setCurrentControl(control);

            if (this._sizeToViewport) {
                this._resizeToViewport();
            }
        }

        public setFooterPanelControl(control) {
            this._footerPanelControlHost.setCurrentControl(control);

            if (this._sizeToViewport) {
                this._resizeToViewport();
            }
        }
    }

}
